module.exports = __webpack_public_path__ + "static/media/34-3.0da2a13c.mp3";